<!--Generic Filters!-->
@if (this.isGeneric) {
  <div style="display: inline; align-items: flex-start;overflow-x: auto" data-cy="report-aging-generic-filters">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container" data-cy="report-aging-grid-list">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="report-aging-report-for-header">
        <p style="font-weight: bolder; padding-top: 10px; padding-left: 5px;  margin-right: auto" data-cy="report-aging-report-for-title">Report For</p>
      </mat-grid-tile>
      <mat-radio-group aria-label="Report For" data-cy="report-aging-report-for-group">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-provider-checkbox-container">
          <mat-checkbox [checked]="true" [(ngModel)]="isReportForProvide"
            (change)="updateFilterByProvider($event.checked)" color="primary" style="word-wrap: inherit"
            data-cy="report-aging-provider-checkbox">
            Provider
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-provider-dropdown-container">
          @if (isReportForProvide) {
            <div style="width: 100%;" data-cy="report-aging-provider-dropdown-wrapper">
              <tdo-dropdown-v2
                [isMultiSelect]="true"
                [isIncludeAll]="true"
                [isPreventMouseEventPropagation]="true"
                [datasource]="staticDataService.currentLocationDoctors" [displayPredicate]="doctorPredicate"
                [value]="selectedProviders"
                (selectionChange)="onDoctorsSelected($event)"
                (closed)="onDoctorsSelected($event)"
                data-cy="report-aging-provider-dropdown">
              </tdo-dropdown-v2>
            </div>
          }
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-practice-checkbox-container">
          <mat-checkbox [checked]="true" [(ngModel)]="isReportForPractice"
            (change)="updateFilterByPractice($event.checked)" color="primary" style="word-wrap: inherit"
            data-cy="report-aging-practice-checkbox">
            Practice
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-practice-dropdown-container">
          @if (isReportForPractice) {
            <div style="width: 100%; margin-bottom: 10px" data-cy="report-aging-practice-dropdown-wrapper">
              <app-tdo-dropdown style="width: 100%; margin-bottom: 10px"
                [dataSource]="clientList"
                dataSourceDisplayKey="Name"
                [isObjectValue]="true"
                [value]="selectedClient"
                (selectionChange)="onChangeClient($event)"
                data-cy="report-aging-practice-dropdown">
              </app-tdo-dropdown>
            </div>
          }
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-location-label-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-aging-location-dropdown-container">
          @if (isReportForPractice) {
            <div style="width: 100%; margin-bottom: 10px" data-cy="report-aging-location-dropdown-wrapper">
              <tdo-dropdown-v2 style="width: 100%; margin-bottom: 10px"
                [isMultiSelect]="true"
                [isIncludeAll]="true"
                [datasource]="locationList" displayProperty="Name" [value]="selectedClientLocation"
                (selectionChange)="onChangeClientLocation($event)"
                (closed)="onChangeClientLocation($event)"
                data-cy="report-aging-location-dropdown">
              </tdo-dropdown-v2>
            </div>
          }
        </mat-grid-tile>
      </mat-radio-group>
    </mat-grid-list>
  </div>
}

<!--Aging Analysis!-->
@if (showParametersForReport=== ReportIDEnum.reportID_AgingAnalysis) {
  <div
    style="display: inline; align-items: flex-start;overflow-x: auto">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; margin-right: auto">What to Report</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <section style="margin-right: auto;">
          <mat-checkbox style="margin-left: 15px" id="isTrueBalance" [formControl]="checkboxTrueBalance"
            (change)="toggle($event)">True Balance
          </mat-checkbox>
        </section>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; margin-right: auto">For Time Period</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
        <section style="margin-right: auto; padding-bottom: 10px">
          <span style="margin-left: 15px">
            <mat-checkbox
              [checked]="allComplete"
              [color]="task.color"
              [indeterminate]="someComplete()"
              (change)="setAll($event.checked)">
              {{task.name}}
            </mat-checkbox>
          </span>
          <span>
            <ul style="margin-left: inherit">
              @for (subtask of task.subtasks; track subtask) {
                <li>
                  <mat-checkbox [(ngModel)]="subtask.completed"
                    style="margin-left: 70px"
                    [color]="subtask.color"
                    (ngModelChange)="updateAllComplete()">
                    {{subtask.name}}
                  </mat-checkbox>
                </li>
              }
            </ul>
          </span>
        </section>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Patient Statement!-->
@if (showParametersForReport=== ReportIDEnum.reportID_PatientStatement) {
  <div style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 20px; margin-right: auto">Enter Statement Note:</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="3" class="mat-grid-tile-container">
        <mat-form-field style="width: 100%;height:80%; " appearance="outline">
          <textarea matInput [(ngModel)]="statementNote" autocomplete="off"></textarea>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--List of Appointments!-->
@if (showParametersForReport === ReportIDEnum.reportID_List_of_Appointments) {
  <div
    style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Financial Summary!-->
@if (showParametersForReport === ReportIDEnum.reportID_FinancialSummary || showParametersForReport === ReportIDEnum.reportID_ProceduresWithNoClaims) {
  <div style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Claims not Sent!-->
@if (showParametersForReport === ReportIDEnum.reportID_ClaimsNoSent ) {
  <div style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}


<!--Outstanding Claims!-->
@if (showParametersForReport === ReportIDEnum.reportID_OutstandingClaims ) {
  <div style="display: inline; align-items: flex-start;overflow-x: auto">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
      <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
        <section style="margin-left: -180px; padding-bottom: 10px">
          <mat-radio-group       class="claims-method-radio-group"
            (change)="updateFilterByAllClaims($event)">
            <mat-radio-button class="insurance-status-option" value="All">All Claims</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="eClaims">e-Claims</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="ADA">Paper Claims (ADA)</mat-radio-button>
          </mat-radio-group>
        </section>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; margin-right: auto">Claims Over</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
        <section style="margin-left: -180px; padding-bottom: 10px">
          <mat-radio-group       class="claims-method-radio-group"
            (change)="updateFilterByOverTIme($event)">
            <mat-radio-button class="insurance-status-option" value="All">All</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="30">Over 30 Days</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="60">Over 60 Days</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="90">Over 90 Days</mat-radio-button>
          </mat-radio-group>
        </section>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Referring Analysis!-->
@if (showParametersForReport === ReportIDEnum.reportID_ReferringAnalysis) {
  <div style="display: inline; align-items: flex-start;overflow-x: auto">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="3" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; margin-right: auto">open</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="3" class="mat-grid-tile-container">
        <section style="margin-left: -260px; padding-bottom: 10px">
          <mat-radio-group       class="claims-method-radio-group"
            (change)="updateFilterByOpen($event)">
            <mat-radio-button class="insurance-status-option" [checked]="true" value="10">Top 10</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="All">All</mat-radio-button>
          </mat-radio-group>
        </section>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
        <p style="font-weight: bolder; margin-right: auto">Include</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
        <section style="margin-left: -180px; padding-bottom: 10px">
          <mat-checkbox [(ngModel)]="IncludePerDoctor" color="primary"
            style="display: block; margin-bottom: 8px;">
            Summary Per Doctor
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="IncludePerCode" color="primary"
            style="display: block; margin-bottom: 8px;">
            Summary Per Code
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="IncludeBreakDown" color="primary"
            style="display: block; margin-bottom: 8px;">
            Break down
          </mat-checkbox>
        </section>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Recall Appointment Report!-->
@if (showParametersForReport === ReportIDEnum.reportID_Recall_Appointment) {
  <div style="display: inline; align-items: flex-start;overflow-x: auto">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="3" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" [disabled]="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" [disabled]="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
        <section style="margin-left: -180px; padding-bottom: 10px">
          <mat-radio-group       class="claims-method-radio-group"
            (change)="updateFilterByRecallAppointment($event)">
            <mat-radio-button class="insurance-status-option" value="followUp" [checked]="true">Follow Up</mat-radio-button>
            <mat-radio-button class="insurance-status-option" value="request">Request</mat-radio-button>
          </mat-radio-group>
        </section>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Call List Report!-->
@if (showParametersForReport === ReportIDEnum.reportID_Call_List) {
  <div style="display: inline; align-items: flex-start;overflow-x: auto">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" style="width: 100%;">
        <input matInput [required]="true" [matDatepicker]="picker"
          [(ngModel)]="startDate" (appInputFinished)="onChangeDate($event)"
          placeholder="'Choose a date'"/>
          <mat-datepicker-toggle (change)="onDatePickerChange($event)" [disabled]="false" matSuffix
          [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Patients Need Appointment Report!-->
  @if (showParametersForReport === ReportIDEnum.reportID_PatientsNeedAppointment) {
    <div style="display: inline; align-items: flex-start;overflow-x: auto">
      <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container" data-cy="report-patients-need-appointment-grid-list" style="margin-top: 10px;">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-patients-need-appointment-practice-checkbox-container">
          <mat-checkbox [checked]="true" [(ngModel)]="isReportForPractice"
            (change)="updateFilterByPractice($event.checked)" color="primary" style="word-wrap: inherit"
            data-cy="report-patients-need-appointment-practice-checkbox">
            Practice
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-patients-need-appointment-practice-dropdown-container">
          @if (isReportForPractice) {
            <div style="width: 100%; margin-bottom: 10px" data-cy="report-patients-need-appointment-practice-dropdown-wrapper">
              <app-tdo-dropdown style="width: 100%; margin-bottom: 10px"
                [dataSource]="clientList"
                dataSourceDisplayKey="Name"
                [isObjectValue]="true"
                [value]="selectedClient"
                (selectionChange)="onChangeClient($event)"
                data-cy="report-patients-need-appointment-practice-dropdown">
              </app-tdo-dropdown>
            </div>
          }
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-patients-need-appointment-location-label-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="report-patients-need-appointment-location-dropdown-container">
          @if (isReportForPractice) {
            <div style="width: 100%; margin-bottom: 10px" data-cy="report-patients-need-appointment-location-dropdown-wrapper">
              <tdo-dropdown-v2 style="width: 100%; margin-bottom: 10px"
                [isMultiSelect]="true"
                [isIncludeAll]="true"
                [datasource]="locationList" displayProperty="Name" [value]="selectedClientLocation"
                (selectionChange)="onChangeClientLocation($event)"
                (closed)="onChangeClientLocation($event)"
                data-cy="report-patients-need-appointment-location-dropdown">
              </tdo-dropdown-v2>
            </div>
          }
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="report-patients-need-appointment-date-range-label-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="3" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" [disabled]="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" [disabled]="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
          <section style="margin-left: -180px; padding-bottom: 10px">
            <mat-checkbox [(ngModel)]="isNewOnly" color="primary"
              style="display: block; margin-bottom: 8px;"
              (change)="toggleNewPatientsOnly($event)">
              New Patients Only
            </mat-checkbox>
          </section>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }
  <!--Fee Calculation Report!-->
  @if (showParametersForReport === ReportIDEnum.reportID_FeeCalculationReport ) {
    <div style="display: inline; align-items: flex-start;overflow-x: auto">
      <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; padding-left: 5px;  margin-right: auto">Order By</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="5" class="mat-grid-tile-container">
          <section style="margin-left: -180px; padding-bottom: 10px">
            <mat-radio-group       class="claims-method-radio-group"
              (change)="updateFilterByFeeCalculationReport($event)">
              <mat-radio-button class="insurance-status-option" value="Date" [checked]="true">As entered</mat-radio-button>
              <mat-radio-button class="insurance-status-option" value="ToothCode">Tooth, Code</mat-radio-button>
            </mat-radio-group>
          </section>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Bank Deposit!-->
  @if (showParametersForReport === ReportIDEnum.reportID_BankDeposits ) {
    <div style="display: inline; align-items: flex-start;overflow-x: auto">
      <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container">
        <mat-grid-tile [colspan]="3" [rowspan]="7" class="mat-grid-tile-container">
          <section style="margin-left: -180px; padding-bottom: 10px">
            <mat-radio-group       class="claims-method-radio-group"
              (change)="updateFilterByBankDeposit($event)">
              <mat-radio-button class="insurance-status-option" value="Cash">Cash</mat-radio-button>
              <mat-radio-button class="insurance-status-option" value="Check">Check</mat-radio-button>
              <mat-radio-button class="insurance-status-option" value="All" [checked]="true">Cash and Check</mat-radio-button>
            </mat-radio-group>
          </section>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Snapshot and Daily Snapshot Report!-->
  @if (showParametersForReport === ReportIDEnum.reportID_DailySnapshot ||showParametersForReport === ReportIDEnum.reportID_FinancialSnapshotReport ) {
    <div
      style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
        @if (showParametersForReport === ReportIDEnum.reportID_FinancialSnapshotReport ) {
          <div>
            <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
              <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
              <tdo-dropdown-v2 style="width: 100%;"
                placeholder="Select Date Range"
                [datasource]="filterDateRangesEnums"
                displayProperty="ItemDisplayValue"
                [value]="selectedDateRanges"
                (selectionChange)="onChangeDateRanges($event)">
              </tdo-dropdown-v2>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
              <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
                <mat-date-range-input [rangePicker]="rangePicker">
                  <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
                  <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </mat-grid-tile>
          </div>
        }
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Order By</p>
        </mat-grid-tile>
        <mat-radio-group aria-label="Order By">
          <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            <mat-radio-button value=true [checked]="true" style="padding-right: 8px" (change)="radioChange($event)">Asc
            </mat-radio-button>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            <mat-radio-button value=false (change)="radioChange($event)">Desc</mat-radio-button>
          </mat-grid-tile>
        </mat-radio-group>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <app-tdo-dropdown
            style="width: 100%;"
            [dataSource]="orderByOptionDaily"
            dataSourceDisplayKey="viewValue"
            [isObjectValue]="true"
            [value]="selectedSnapShotOrderBy"
            (selectionChange)="onChangeOrderByOptionDaily($event)" required>
          </app-tdo-dropdown>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Miscellaneous</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container">
          <div style="padding-left: 22px; margin-right: auto">
            <section>
              <mat-checkbox id="isInteractiveReport" checked="true" [formControl]="checkboxSnapShotReport"
                (change)="toggleInteractiveReport($event)">Show Interactive Report
              </mat-checkbox>
            </section>
          </div>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container">
          <div style="padding-left: 22px; margin-right: auto">
            <section>
              <mat-checkbox id="showInactive" [formControl]="checkboxShowActiveDoctors" (change)="showInactiveDoc($event)">
                Show Inactive Doctors
              </mat-checkbox>
            </section>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Transaction Report!-->
  @if (showParametersForReport=== ReportIDEnum.reportID_TransactionReport) {
    <div style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; padding-left: 5px;  margin-right: auto">Report For</p>
        </mat-grid-tile>
        <mat-radio-group aria-label="Report For">
          <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            <mat-checkbox [checked]="true" [(ngModel)]="isReportForProvide"
              (change)="updateFilterByProvider($event.checked)" color="primary" style="word-wrap: inherit">
              Provider
            </mat-checkbox>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
            @if (isReportForProvide) {
              <div style="width: 100%;">
                <tdo-dropdown-v2
                  [isMultiSelect]="true"
                  [isIncludeAll]="true"
                  [isPreventMouseEventPropagation]="true"
                  [datasource]="staticDataService.currentLocationDoctors" [displayPredicate]="doctorPredicate"
                  [value]="selectedProviders"
                  (selectionChange)="onDoctorsSelected($event)"
                  (closed)="onDoctorsSelected($event)">
                </tdo-dropdown-v2>
              </div>
            }
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
            <mat-checkbox [checked]="true" [(ngModel)]="isReportForPractice"
              (change)="updateFilterByPractice($event.checked)" color="primary" style="word-wrap: inherit">
              Practice
            </mat-checkbox>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
            @if (isReportForPractice) {
              <div style="width: 100%; margin-bottom: 10px">
                <app-tdo-dropdown style="width: 100%; margin-bottom: 10px"
                  [dataSource]="clientList"
                  dataSourceDisplayKey="Name"
                  [isObjectValue]="true"
                  [value]="selectedClient"
                  (selectionChange)="onChangeClient($event)">
                </app-tdo-dropdown>
              </div>
            }
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
            @if (isReportForPractice) {
              <div style="width: 100%; margin-bottom: 10px">
                <tdo-dropdown-v2 style="width: 100%; margin-bottom: 10px"
                  [isMultiSelect]="true"
                  [isIncludeAll]="true"
                  [datasource]="locationList" displayProperty="Name" [value]="selectedClientLocation"
                  (selectionChange)="onChangeClientLocation($event)"
                  (closed)="onChangeClientLocation($event)">
                </tdo-dropdown-v2>
              </div>
            }
          </mat-grid-tile>
        </mat-radio-group>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 20px; margin-right: auto">Transactions</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="6" class="mat-grid-tile-container">
          <mat-radio-group>
            <mat-radio-button value="Check" [checked]="true" (change)="radioTransactionChange($event)"
              style="margin-left: 10px; margin-top: 11px">Check / Cash
            </mat-radio-button>
            <mat-radio-button value="CreditCard" (change)="radioTransactionChange($event)"
              style="margin-left: 10px; margin-top: 12px">Credit Card Activity
            </mat-radio-button>
            <mat-radio-button value="Debit" (change)="radioTransactionChange($event)"
              style="margin-left: 10px; margin-top: 12px">Debit/ATM/E-Check
            </mat-radio-button>
            <mat-radio-button value="Other" (change)="radioTransactionChange($event)"
              style="margin-left: 10px; margin-top: 12px">Other
            </mat-radio-button>
          </mat-radio-group>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Voided Transaction!-->
  @if (showParametersForReport=== ReportIDEnum.reportID_VoidedTransactionReport) {
    <div
      style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 20px; margin-right: auto">Order By</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="6" class="mat-grid-tile-container">
          <mat-radio-group>
            <mat-radio-button value=true [checked]="true" (change)="radioVoidedTransactionChange($event)"
              style="margin-left: 10px; margin-top: 11px">Date Charged
            </mat-radio-button>
            <mat-radio-button value=false (change)="radioVoidedTransactionChange($event)"
              style="margin-left: 10px; margin-top: 12px">Date Voided
            </mat-radio-button>
          </mat-radio-group>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Ledger Transaction!-->
  @if (showParametersForReport=== ReportIDEnum.reportID_LedgerTransactionReport) {
    <div
      style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="33px" class="grid-list-container">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 0px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="12" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 20px; margin-right: auto; margin-bottom: auto">Report</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="12" class="mat-grid-tile-container">
          <ul style="margin-right: 45px">
            <mat-checkbox
              [checked]="allLedgerReports"
              [color]="reports.color"
              [indeterminate]="someReportsComplete()"
              (change)="setAllLedgerReports($event.checked)">
              {{reports.name}}
            </mat-checkbox>
            @for (subtask of reports.subtasks; track subtask) {
              <li>
                @if (subtask.name !== 'Transactions (type)') {
                  <mat-checkbox [(ngModel)]="subtask.completed"
                    [color]="subtask.color"
                    (ngModelChange)="updateAllLedgerReportsComplete()">
                    {{subtask.name}}
                  </mat-checkbox>
                }
                @if (subtask.name === 'Transactions (type)') {
                  <mat-checkbox [(ngModel)]="subtask.completed"
                    [checked]="allLedgerTransactionReports"
                    [color]="subtask.color"
                    [indeterminate]="someLedgerTransactionsReportsComplete()"
                    (change)="setAllLedgerTransactionReports($event.checked)">
                    {{subtask.name}}
                  </mat-checkbox>
                }
                <ul>
                  @for (subtaskChild of subtask.subtasks; track subtaskChild) {
                    <li>
                      <mat-checkbox [(ngModel)]="subtaskChild.completed"
                        [color]="subtaskChild.color"
                        (ngModelChange)="updateAllLedgerTransactionReports()">
                        {{subtaskChild.name}}
                      </mat-checkbox>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
          <!--<p style="font-weight: bolder; margin-top: 10px; margin-right: auto">Format</p>!-->
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Financial Audit!-->
  @if (showParametersForReport=== ReportIDEnum.reportID_Financial_AuditReport) {
    <div
      style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  }

  <!--Credit Card Receipt!-->
  @if (showParametersForReport=== ReportIDEnum.reportID_CreditCardReceiptReport) {
    <div
      style="display: inline; align-items: flex-start;">
      <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
        <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Report For</p>
        </mat-grid-tile>
        <mat-radio-group>
          <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container">
            <mat-radio-button value=true [checked]="true" (change)="PatientSelectedChange($event)" style="margin-right: auto; margin-left: 10px">Current Patient</mat-radio-button>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container">
            <mat-radio-button value=false (change)="PatientSelectedChange($event)" style="margin-right: auto; margin-left: 10px">All</mat-radio-button>
          </mat-grid-tile>
        </mat-radio-group>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
          <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <tdo-dropdown-v2 style="width: 100%;"
            placeholder="Select Date Range"
            [datasource]="filterDateRangesEnums"
            displayProperty="ItemDisplayValue"
            [value]="selectedDateRanges"
            (selectionChange)="onChangeDateRanges($event)">
          </tdo-dropdown-v2>
          <div matTooltip="Search Payments" matTooltipPosition="right" style="cursor: pointer; width: fit-content; height: 26px; color: var(--tdo-primary-accent);" (click)="GetCCPaymentList()"><lucide-icon name="search" [size]="20" style="padding-left: 3px;"></lucide-icon></div>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
          <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </mat-grid-tile>
        <!--<mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
        <button class="tdo-button tdo-save" color="primary" (click)="GetCCPaymentList()">Find Payments</button>
      </mat-grid-tile>!-->
      <mat-grid-tile  [colspan]="3" [rowspan]="8" class="mat-grid-tile-container">
        <tdo-table [dataSource]="PaymentList"
          [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
          [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)">
          <tdo-table-column displayName="Patient Name" propertyName="PatientFullName" isSortable="true" [rowTemplate]="PatientFullName">
            <ng-template #PatientFullName let-row>
              {{ row.PatientFullName }}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Date" propertyName="PaymentTransactionDate" isSortable="true" [rowTemplate]="PaymentTransactionDate">
            <ng-template #PaymentTransactionDate let-row>
              {{ row.PaymentTransactionDate | date: 'MM/dd/yyyy' }}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Amount" propertyName="PaymentAmount" isSortable="true" [rowTemplate]="PaymentAmount">
            <ng-template #PaymentAmount let-row>
              {{ row.PaymentAmount | currency }}
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Recall Report!-->
@if (showParametersForReport=== ReportIDEnum.reportID_RecallReport) {
  <div
    style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Deleted Anesthesia-->
@if (showParametersForReport=== ReportIDEnum.reportID_Deleted_Anesthesia) {
  <div
    style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}

<!--Patient Case Referrals-->
@if (showParametersForReport=== ReportIDEnum.reportID_Patient_Case_Referrals) {
  <div
    style="display: inline; align-items: flex-start;">
    <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto">Date Range</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <tdo-dropdown-v2 style="width: 100%;"
          placeholder="Select Date Range"
          [datasource]="filterDateRangesEnums"
          displayProperty="ItemDisplayValue"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)">
        </tdo-dropdown-v2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
        <mat-form-field appearance="fill" class="example-form-field" style="width: 100%">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
}






